import React from 'react';
import { Avatar } from '../atoms/Avatar';

/**
 * UserProfileCard Component - Molecular Level
 * 
 * Displays user profile information in sidebar
 * 
 * Features:
 * - User avatar with status
 * - User name and role
 * - Dropdown menu
 * - Collapsed state support
 */

export interface UserProfileCardProps {
  /** User's name */
  name: string;
  /** User's role/title */
  role?: string;
  /** Avatar image URL */
  avatarUrl?: string;
  /** Online status */
  status?: 'online' | 'offline' | 'away';
  /** Whether sidebar is collapsed */
  isCollapsed?: boolean;
  /** Click handler for profile menu */
  onClick?: () => void;
}

export const UserProfileCard: React.FC<UserProfileCardProps> = ({
  name,
  //role,
  avatarUrl,
  status = 'online',
  isCollapsed = false,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={`
        w-full flex items-center gap-3 p-3 transition-all duration-200
        hover:bg-white/10 rounded-lg
        ${isCollapsed ? 'justify-center' : ''}
      `}
      aria-label={`${name} profile menu`}
    >
      <Avatar
        name={name}
        src={avatarUrl}
        size={isCollapsed ? 'md' : 'md'}
        showStatus={true}
        status={status}
      />
      
      {!isCollapsed && (
        <div className="flex-1 text-left min-w-0">
          <p className="text-sm font-semibold text-white truncate">
            {name}
          </p>
          {/* {role && (
            <p className="text-xs text-gray-300 truncate">
              {role}
            </p>
          )} */}
        </div>
      )}
      
      {!isCollapsed && (
        <svg
          className="w-4 h-4 text-gray-300 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      )}
    </button>
  );
};

export default UserProfileCard;

